import { configQuery, languageQuery } from '@gig/magic-common';
import { LANGUAGE_UPDATED, TRANSLATIONS_LOADED, TRANSLATIONS_QUERY } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { Language } from '@gig/magic-sdk/dist/adapter/users/language';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const LANGUAGE_CACHE_KEY = "pw-i18n-{language}-v2";
class TranslationService {
  constructor() {
    configQuery("environment").then((environment) => {
      this.environment = environment;
      this.registerEvents();
      this.subscribeToLanguageChangeEvent();
    });
  }
  subscribeToLanguageChangeEvent() {
    window.eventBus.subscribe(LANGUAGE_UPDATED, (event) => __async(this, null, function* () {
      const language = event.payload;
      if (!language) {
        return null;
      }
      this.unregisterQueryHandler();
      this.translations = yield this.getTranslations(language);
      if ((yield languageQuery()) === language) {
        this.registerQueryHandler();
      }
      window.eventBus.publish(TRANSLATIONS_LOADED, {
        translations: this.translations,
        language
      });
    }), { replay: true });
  }
  registerEvents() {
    window.eventBus.register(TRANSLATIONS_LOADED, {
      type: "object",
      properties: {
        translations: {
          type: "array"
        },
        language: {
          type: "string"
        }
      }
    });
    window.queryBus.register(TRANSLATIONS_QUERY, {
      type: "string",
      enum: Object.values(Language)
    });
  }
  unregisterQueryHandler() {
    var _a;
    (_a = this.querySubscription) == null ? void 0 : _a.unsubscribe();
  }
  registerQueryHandler() {
    this.querySubscription = window.queryBus.subscribe(TRANSLATIONS_QUERY, () => {
      return this.translations;
    });
  }
  getTranslations(language) {
    return __async(this, null, function* () {
      const cachedTranslations = this.loadFromCache(language);
      if (cachedTranslations) {
        this.fetchTranslations(language);
        return cachedTranslations;
      }
      return yield this.fetchTranslations(language);
    });
  }
  fetchTranslations(language) {
    return __async(this, null, function* () {
      const translations = yield magic.methods.translations.fetch(language, this.environment === "production");
      this.saveIntoCache(language, translations);
      return translations;
    });
  }
  saveIntoCache(language, translations) {
    try {
      window.localStorage.setItem(LANGUAGE_CACHE_KEY.replace("{language}", language), JSON.stringify(translations));
      return true;
    } catch (e) {
      return false;
    }
  }
  loadFromCache(lang) {
    try {
      const item = window.localStorage.getItem(LANGUAGE_CACHE_KEY.replace("{language}", lang));
      return item && JSON.parse(item) || null;
    } catch (e) {
      return null;
    }
  }
}

export { LANGUAGE_CACHE_KEY, TranslationService };
